import React from 'react'
import { array, string } from 'prop-types'
import DateHelper from '../../../../_plugins/lib/dateHelper.js'

const getFirstDayOfCurrentMonth = (date, type) => {
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  if (type === 'full') return firstDay.getDate() + DateHelper.getOrdinal(firstDay.getDate())
  if (type === 'iso') return getISO8601DateString(firstDay)
}

const getLastDayOfCurrentMonth = (date, type) => {
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  if (type === 'full') return lastDay.getDate() + DateHelper.getOrdinal(lastDay.getDate())
  if (type === 'iso') return getISO8601DateString(lastDay)
}

const getISO8601DateString = date => {
  const month = (date.getMonth() + 1).toString()
  const paddedMonth = ('00' + month).substring(month.length)
  const day = (date.getDate()).toString()
  const paddedDay = ('00' + day).substring(day.length)
  return date.getFullYear() + '-' + paddedMonth + '-' + paddedDay
}
const EngineActionVoucher = ({ id, functionParams }) => {
  if (!functionParams || functionParams.length < 5) return null
  let [discount, title, productImageUrl, customText, product] = functionParams

  const todaysDate = new Date()
  const firstDayOfMonth = getFirstDayOfCurrentMonth(todaysDate, 'full')
  const lastDayOfMonth = getLastDayOfCurrentMonth(todaysDate, 'full')
  const monthAndYearName = DateHelper.getMonthName(todaysDate.getMonth()) + ' ' + todaysDate.getFullYear()
  const startIso = getFirstDayOfCurrentMonth(todaysDate, 'iso')
  const endIso = getLastDayOfCurrentMonth(todaysDate, 'iso')

  return (
    <div id={id} className='panel panel-primary'>
      <div className='panel-heading'> 
        <div className='row'>
          <div className='col-xs-12 col-sm-10'>
            <img className='pull-left' data-original={`https://${productImageUrl}`} />
            <h3 className='mt-0'>
              <span className='text-warning py-3'>
                {discount}% off {' '}
              </span> 
                {title}
            </h3>
            <span className='discount-date' id={`${id}-date`}>
              <small>
                <time itemProp='startDate' dateTime={startIso}>
                  Added {firstDayOfMonth} {monthAndYearName} {' - '}
                </time>
                <time itemProp='endDate' dateTime={endIso}>
                  Expires {lastDayOfMonth} {monthAndYearName}
                </time>
              </small>
            </span>
          </div>
          <div className='col-xs-12 col-sm-2 text-center' >
            <a href='#' data-discount={discount} data-product={product} name='apply-discount' className='btn btn-primary engineActionButton'>
              Apply discount
            </a>
          </div>
        </div>          
      </div>
      <div className='clearfix px-4 pb-4' dangerouslySetInnerHTML={{__html: customText}} />
    </div>
  )
}

EngineActionVoucher.propTypes = {
  functionParams: array.isRequired,
  id: string.isRequired
}

export default EngineActionVoucher



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engineActionVoucher.jsx